import { create } from "zustand"

interface RecommendedCoachVideoModalStore {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
}

export const useRecommendedCoachVideoModalStore =
  create<RecommendedCoachVideoModalStore>((set) => ({
    isOpen: false,
    onOpen: () => set({ isOpen: true }),
    onClose: () => set({ isOpen: false }),
  }))
